import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=3a1a903f&"
import script from "./NewTask.vue?vue&type=script&lang=js&"
export * from "./NewTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports